import React from 'react';

const PrismNews = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Prism News</h1>
      <p>
        I built this because staying informed is costly. Wading through biased, noisy sources takes time and honestly isn't fun. 
        But being uninformed feels worse. AI can be more objective than humans when applied thoughtfully. 
        Prism de-noises thousands of sources daily, removes bias, and delivers what matters via a Telegram bot.
      </p>

      <h2>Technicals</h2>
      <ul>
        <li>Scraping 10,000+ sources daily</li>
        <li>Multi-gated AI + logic filters to analyse, de-noise, and assess importance</li>
        <li>Structured database</li>
        <li>
          Delivered via Telegram bot. For example, pressing <code>'w'</code> provides the user with the top ten world
          news stories for that day
        </li>
      </ul>

      <h2>Coverage</h2>
      <ul>
        <li>Global politics and policy</li>
        <li>World events</li>
        <li>Regional developments</li>
        <li>Technology and innovation</li>
        <li>Sports and culture</li>
        <li>Market updates</li>
        <li>And more</li>
      </ul>

      <h2>Launching Soon</h2>
      <p>
        Prism News is currently with a small user group and will be launched soon. Targeting people who value their time and want to stay informed without the noise.
      </p>
      <p>
        prismnews.ai
      </p>
    </main>
  );
};

export default PrismNews;